import Vue, { toRaw } from "vue";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function spawnDialog(dialog, props = {}, optionsOrOnClose = {}, onClose = () => {
}) {
  if (typeof optionsOrOnClose === "function") {
    onClose = optionsOrOnClose;
    optionsOrOnClose = {};
  }
  let { container } = optionsOrOnClose;
  if ("container" in props && typeof props.container === "string") {
    container != null ? container : container = props.container;
  }
  const resolvedContainer = typeof container === "string" && document.querySelector(container) || document.body;
  const element = resolvedContainer.appendChild(document.createElement("div"));
  const vm = new Vue({
    el: element,
    name: "VueDialogHelper",
    render: (h) => h(dialog, {
      props: __spreadValues({
        // If dialog has no `container` prop passing a falsy value does nothing
        // Otherwise it is expected that `null` disables teleport and mounts dialog in place like NcDialog/NcModal
        container: null
      }, props),
      on: {
        close: (...rest) => {
          onClose(...rest.map((v) => toRaw(v)));
          vm.$destroy();
          element.remove();
        }
      }
    })
  });
  return vm;
}
export {
  spawnDialog
};
//# sourceMappingURL=dialog.mjs.map
